import RequestAbstract from "./RequestAbstract";

export default class Post extends RequestAbstract {
    get link() {
        return this.links.posts;
    }

    async viewTags() {
        return await this.post(this.link + "/viewTags");
    }

    async getDraftAccounts(id) {
        return await this.post(this.link + "/getAccountPosts/" + id);
    }
}
